import React, { useEffect, useState } from "react";
import Header from "../component/layout/Header";
import Footer from "../component/layout/Footer";
import BlogDetail from "../component/BlogDetails/BlogDetail";
import { useParams } from "react-router-dom";
import api from "../utils/api";
import { ClipLoader } from "react-spinners"; // Loader for the loading state
import { FaSpinner } from "react-icons/fa";

const BlogDetailPage = () => {
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const { slug } = useParams(); // Get blog id from the URL
  console.log("\ud83d\ude80 ~ BlogDetailPage ~ id:", slug);
  React.useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);
  useEffect(() => {
    const fetchBlogDetails = async () => {
      try {
        setLoading(true); // Set loading to true when starting fetch
        const response = await api.get(`/blog-post`);
        console.log("\ud83d\ude80 ~ fetchBlogDetails ~ response:", response);

        const blogs = response.data.results; // Extract the list of blogs

        // Find the blog by comparing _id from the data with id from the URL (ensuring the types match)
        const foundBlog = blogs.find((b) => b.slug === slug); // Use _id for comparison
        console.log("\ud83d\ude80 ~ fetchBlogDetails ~ foundBlog:", foundBlog);

        if (foundBlog) {
          setBlog(foundBlog);
        } else {
          console.error(`Blog with ID ${slug} not found`);
        }
      } catch (error) {
        console.error("Error fetching blog details:", error);
      } finally {
        setLoading(false); // Set loading to false when fetch is complete
      }
    };

    fetchBlogDetails();
  }, [slug]); // Fetch details based on blog ID

  // Show loader while loading
  if ( loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
      </div>
    );
  }

  // If no blog is found, return a fallback message
  if (!blog) {
    return <div className="flex justify-center items-center min-h-screen">Blog not found</div>;
  }

  return (
    <>
      <Header />
      <BlogDetail blog={blog} />
      <Footer />
    </>
  );
};

export default BlogDetailPage;
